import { Component, Host, h } from "@stencil/core";
import state from "@stores/price.store";

@Component({
  tag: "bcp-stock-activity-indicator",
  styleUrl: "bcp-stock-activity-indicator.scss",
})
export class StockActivityIndicator {
  render() {
    return (
      <Host>
        <slot></slot>
        {state.get("loadingStocks") && (
          <bcp-activity-indicator is-absolute is-inline />
        )}
      </Host>
    );
  }
}
